import { render, staticRenderFns } from "./WatchdogsDetails.vue?vue&type=template&id=fb1595cc&lang=pug&"
import script from "./WatchdogsDetails.vue?vue&type=script&lang=js&"
export * from "./WatchdogsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports